<template>
  <div
    class="data-table"
  >
    <div class="menu row-center" style="justify-content:space-between">
      <div class="row-center">
        <el-select v-model="node" class="select"  style="width:80px;margin-right:10px"   v-if="uid === 'Complex'||uid === 'PowerTime'||uid === 'Range'">
          <el-option
            v-for="item in TypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          :editable="false"
          :picker-options="pickerOptions"
          :clearable="false"
          class="dateSelect"
          v-model="date"
          :format="radio === 'week'?'yyyy 第 WW 周':''"
          :type="radio === 'day' ? 'date' : radio"
          :placeholder="new Date().toLocaleDateString().replace(/\//g, '-')"
        >
        </el-date-picker>

        <div class="radio" v-if="uid != 'Range'">
          <el-radio
            v-model="radio"
            label="year">年</el-radio>
          <el-radio v-model="radio" label="month">月</el-radio>
          <el-radio v-model="radio" label="week">周</el-radio>
          <el-radio v-model="radio" label="day" >日</el-radio>
        </div>
        <div class="btn per" @click="perD" v-if="radio === 'day'">上一日</div>
        <div class="btn per" @click="perM" v-if="radio === 'month'">上一月</div>
        <div class="btn per" @click="perW" v-if="radio === 'week'">上一周</div>
        <div class="btn per" @click="perY" v-if="radio === 'year'">上一年</div>
        <el-button
          class="btn next"
          plain
          @click="nextD"
          v-if="radio === 'day'"
          :disabled="nextDayDisabled"
          >下一日
        </el-button>
        <el-button
          class="btn next"
          plain
          @click="nextM"
          v-if="radio === 'month'"
          :disabled="nextDayDisabled"
        >
          下一月
        </el-button>
        <el-button
          class="btn next"
          plain
          @click="nextW"
          v-if="radio === 'week'"
          :disabled="nextDayDisabled"
        >
          下一周
        </el-button>
        <el-button
          class="btn next"
          plain
          @click="nextY"
          v-if="radio === 'year'"
          :disabled="nextDayDisabled"
          >下一年
        </el-button>
      </div>
      <div class="export row-center">
        <img
          style="width: 14px; height: 14px"
          src="../../assets/img/export.png"
          alt=""
        />
        <span
          style="font-size: 14px; cursor: pointer"
          @click="
            $store.commit('exportDiagram', {
              type: 'excel',
              version: Math.random(),
            })
          "
          >导出报表</span
        >
      </div>
    </div>
    <div class="report" >
      <PowerTime
        v-if="uid === 'PowerTime'"
        :date="date"
        :node="node"
        :range="radio"
        :loops="selectedLoops"
      ></PowerTime>
      <PowerRange
        v-if="uid === 'Range'"
        :date="date"
        :range="radio"
        :node="node"
        :loops="selectedLoops"
      ></PowerRange>
      <Suboption
        v-if="uid === 'Suboption'"
        :date="date"
        :range="radio"
        :loops="selectedLoops"
      ></Suboption>
      <Complex
        v-if="uid === 'Complex'"
        :date="date"
        :range="radio"
        :node="node"
        :loops="selectedLoops"
      ></Complex>
    </div>
  </div>
</template>
<script>
import {
  perDay,
  perMonth,
  perYear,
  nextDay,
  nextMonth,
  nextYear,
  dateFormat,
  addDay,
  getAppointedDate
} from "../../util/DateUtil";
import PowerTime from "./report/PowerTime";
import PowerRange from "./report/PowerRange";
import Suboption from "./report/Suboption";
import Complex from "./report/Complex";
import exportExcel from "../../util/excel";
export default {
  name: "PowerDataBase",
  props: {
    realData: Array,
    options: Array,
    currentLoop: Object,
    selectedLoops: Array,
  },
  components: {
    PowerTime,
    PowerRange,
    Complex,
    Suboption,
  },
  data() {
    let that = this;
    return {
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      date: new Date(),
      radio: "day",
      node:"electricity",
    };
  },
  computed: {
    TypeOptions(){
      if(this.uid=='Complex'){
        return [{
              value: 'electricity',
              label: '电'
          },
          {
              value: 'water',
              label: '水'
          },{
              value: 'heat',
              label: '热'
          },{
              value: 'cooling',
              label: '冷'
          }
      ]
      }
      if(this.uid=='PowerTime'){
        return [{
              value: '',
              label: '总'
          },{
              value: 'electricity',
              label: '电'
          },
          {
              value: 'water',
              label: '水'
          },{
              value: 'heat',
              label: '热'
          },{
              value: 'cooling',
              label: '冷'
          }
      ]
      }
      if(this.uid=='Range'){
        return [
        {
          label: "对比",
          value: 0,
        },{
          label: "计划",
          value: 1,
        }]
      }
    },
    //路由名称
    routeName() {
      return this.$route.params.name;
    },
    //路由tag
    tag() {
      return this.$route.params.tag;
    },
    uid(){
        return  this.$route.query.uid
    },
    nextDayDisabled() {
      let timestamp = dateFormat("YY-mm-dd", new Date());
      let endtime = dateFormat("YY-mm-dd", this.date);
      if (this.radio === "year") {
        timestamp = dateFormat("YY", new Date());
        endtime = dateFormat("YY", this.date);
      } else if (this.radio === "month") {
        timestamp = dateFormat("YY-mm", new Date());
        endtime = dateFormat("YY-mm", this.date);
      }else if (this.radio === "week") {
        timestamp = dateFormat("YY-mm-dd", new Date());
        endtime = dateFormat("YY-mm-dd", addDay(this.date,5));
      }
      if (endtime >= timestamp) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {

  },
  async mounted() {
    if (this.uid == "Range") {
      this.node = 0;
      this.radio = "month"
    }else if (this.uid == "PowerTime") {
      this.node = "";
      this.radio = "day"
    }else{
      this.node = 'electricity';
      this.radio = "day"
    }
  },
  watch: {
    currentLoop(n, o) {},
    uid(n) {
      if (n == "Range") {
        this.node = 0;
        this.radio = "month"
      }else if (n == "PowerTime") {
        this.node = "";
        this.radio = "day"
      }else{
        this.node = 'electricity';
        this.radio = "day"
      }
    },
    radio(n) {
      this.date = new Date();
    },
  },
  methods: {
    perW(){
      let week = getAppointedDate(this.date,1, 1)
      this.date = new Date(week.startDate);
    },
    nextW(){
      let week = getAppointedDate(this.date,1,-1)
      this.date = new Date(week.startDate);
    },
    perD() {
      this.date = perDay(this.date);
    },
    nextD() {
      this.date = nextDay(this.date);
    },
    perM() {
      this.date = perMonth(this.date);
    },
    nextM() {
      this.date = nextMonth(this.date);
    },
    perY() {
      this.date = perYear(this.date);
    },
    nextY() {
      this.date = nextYear(this.date);
    },
  },
};
</script>

<style scoped lang="less">

.el-dropdown-menu__item.active {
  color: #0d94ff;
}

.report {
  margin-top: 24rem;
  // .h(765);
  height:calc(100% - 70rem);
}

.export {
  // margin-left: 23rem;

  img {
    margin-right: 7rem;
  }

  span {
    font-size: 18rem;
    font-weight: 500;
    color: #333333;
  }
}

.btn {
  .w(96);
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
  background-color: #0d94ff;
  cursor: pointer;
  border-radius: 4rem;
  overflow: hidden;
  padding: 0px;
}

.per,
.next {
  background-color: #fff;
  font-size: 18rem;
  color: #666666;
  font-weight: 400;
  border: 1px solid rgba(0, 0, 0, 0.15);

  &:hover {
    background-color: #0d94ff;
    color: #ffffff;
  }
}

.el-button.is-plain:hover {
  background-color: #0d94ff !important;
  color: #ffffff !important;
  transition: 0s;
}

.el-button.is-active,
.el-button.is-plain:active,
.el-button.is-plain:focus {
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  color: #666666;
}

.el-button.is-disabled:hover {
  background-color: #ffffff !important;
  color: #c0c4cc !important;
  transition: 0s;
}

.per {
  margin-left: 8rem;
}
.next {
  margin-left: 8rem;
}

.node-select,
.dateSelect {
  .w(150) !important;
  // .h(40) !important;
}

.node-select {
  margin-right: 24rem;
}

.data-table {
  padding: 24rem;
  background-color: #fff;
  width: 100%;
  height: 100%;

  .menu {
    // margin-top: 24rem;

    .export {
      // margin-left: 61rem;
    }

    .radio {
      margin-left: 10rem;

      .el-radio {
        margin-right: 10rem;
      }
    }
  }

  .title {
    font-size: 18rem;
    font-weight: bold;
    color: #333333;
  }
}

</style>
